if (typeof customElements.get('subscription-button') === 'undefined') {
	class SubscriptionButton extends HTMLElement {
		connectedCallback() {
			if (this._enhanced) return;
			this._enhanced = true;

			this._anchor = this.querySelector('[data-js-subscription-button]');
			if (!this._anchor) return;

			this._onClick = this._onClick.bind(this);
			this._anchor.addEventListener('click', this._onClick);
		}

		disconnectedCallback() {
			if (this._anchor && this._onClick) {
				this._anchor.removeEventListener('click', this._onClick);
			}
		}

		_onClick(event) {
			const handle = this._anchor?.dataset.productHandle;
			const formId = handle ? `SubscriptionProduct-${handle}` : null;
			const form = formId ? document.getElementById(formId) : null;

			if (!form) return;

			const action = form.querySelector('#more-payment-options-link');

			if (!action) return;

			if (event) event.preventDefault();
			action.click();
		}
	}

	customElements.define('subscription-button', SubscriptionButton);
}
